// Auto-generated from Contentful - DO NOT EDIT
// Generated at: 2026-02-04T02:14:54.504Z

const videoTourStaffFolder = {
  pageName: `Staff Folder`,
  tourTitle: `Manage your Staff in the Staff Folder`,
  videoUrl: `https://www.loom.com/embed/a0779f9a47174b2f9268ca2b10a3c48e`,
  description: `Here’s where you can manage all of your staff. Set up new staff, update staff for promotions, and handle corrective actions and terminations all through here.`,
  buttonLabel: `Got it, Thanks!`,
} as const;

export default videoTourStaffFolder;
